import { useQuery } from '@apollo/client';
import {
  CardListLoading,
  COMMON_CONSTANTS,
  EventEmitter,
    getTranslatedText,
  useProduct
} from '@nile/components';
import { GET_ENTITY_PROPERTIES, TicketClient } from '@nile/graphql';
import { ProjectListingHeader } from '@nile/projects/src/Components/Headers';
import { ProjectListCardContainer } from '@nile/projects/src/Containers';
import React, { useState, useEffect, useContext } from 'react';
import TabContext from '@nile/mangifera/src/Contexts/TicketContext';
import { withRouter } from 'react-router-dom';
import { GET_PROJECTS } from '@nile/projects/src/Graphql';
import { useGlobalState } from '@nile/components/src/Managers/StateManager';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';
import { isEqual } from 'lodash';
import {  useCheckIsItProduct } from '@nile/components/src/Utils/helpers';

const arr = [
  'client',
  'owner',
  'title',
  'status',
  'scheduledStartDate',
  'dueDate',
  'overdue'
];

const ProjectListCard = (props) => {
  const { allEntities, projectViews, intl } = props;
  const { id } = props.match.params;

  const tabContext = useContext(TabContext);
  const [totalCount, setTotalCount] = useState(0);
  const [projectList, setProjectList] = useState([]);
  const [personalization, setPersonalization] = useState([]);
  const [loading, setLoading] = useState(false);
  const ROW_COUNT = 50;
  const isMSPProduct = useProduct(COMMON_CONSTANTS.MSP);
  const isItProduct = useCheckIsItProduct();
  const DEFAULTS_LISTINFO = {
    page: 1,
    pageSize: ROW_COUNT,
    sort: [
      {
        attribute: 'createdTime',
        order: 'DESC'
      }
    ]
  };
  const [viewId, setViewId] = useState(id);
  const listInfo = tabContext.projectListInfo;
  const setListInfo = (infoDetails) => {
    tabContext.setProjectListInfo(infoDetails);
  };
  const updateList = () => {
    setLoading(true);
    TicketClient.query({
      query: GET_PROJECTS,
      variables: {
        listInfo: {
          ...listInfo,
          page: listInfo.page,
          pageSize: listInfo.pageSize,
          sort: listInfo.sort,
          view: { id: id }
        },
        isItProduct: !!isItProduct
      },
      fetchPolicy: 'network-only'
    }).then((res) => {
      setTotalCount(res.data.getProjects.listInfo.totalCount);
      setViewId(id);
      setProjectList(res.data.getProjects.projects);
      setLoading(false);
    });
  };

  const getReferredEntityData = (data) => {
    const { meta, entityName, attributeName } = data;
    const filteredEntity = meta.find((entity) => {
      return entity.name === entityName;
    });
    const filteredAttribute = filteredEntity?.attributes.find((el) => {
      return el.name === 'name';
    });
    return {
      ...filteredAttribute,
      name: attributeName,
      label: `${getTranslatedText(
        intl,
        filteredAttribute.attributePlaceHolder.label
      )}`
    };
  };

  const setCurrentPersonalization = () => {
    const projectDataAttributes = allEntities.find(
      (item) => item.name === 'Project'
    ).attributes;

    const personalizedList = [];

    projectDataAttributes.map((attribute) => {
      switch (attribute.name) {
        case 'client':
          if (!isMSPProduct) {
            return;
          }
          const clientAttributeObj = getReferredEntityData({
            intl,
            meta: allEntities,
            entityName: 'Client',
            attributeName: 'client.name'
          });
          if (clientAttributeObj) {
            personalizedList.push(clientAttributeObj);
          }
          break;
        case 'owner':
          const ownerAttributeObj = getReferredEntityData({
            intl,
            meta: allEntities,
            entityName: 'User',
            attributeName: 'owner.name'
          });
          if (ownerAttributeObj) {
            personalizedList.push(ownerAttributeObj);
          }
          break;
        default:
          arr.forEach((el) => {
            if (el === attribute.name) {
              personalizedList.push({
                ...attribute,
                label: getTranslatedText(intl, attribute.label)
              });
            }
          });
      }
    });
    setPersonalization(personalizedList);
    tabContext.setPersonalization(personalizedList);
  };

  useEffect(() => {
    setCurrentPersonalization();
  }, []);

  useEffect(() => {
    //trigger the getprojects api when updating the project view
    EventEmitter.subscribe('refreshProjectList', updateList);
    return function cleanup() {
      EventEmitter.unsubscribe('refreshProjectList');
    };
    // dependencies - we are passing id to getproject api from match.params in updateList function
  }, [props.match?.params?.id]);

  useEffect(() => {
    const view = projectViews.find((pview) => pview.id === id);
    tabContext.setActiveView(view);
    setCurrentPersonalization();
    if (viewId !== view.id) {
      // view changed - reset the listinfo and filter condition
      setListInfo(DEFAULTS_LISTINFO);
    }
  }, [id]);

  useEffect(() => {
    updateList();
  }, [listInfo]);

  const handlePageChange = (page) => {
    setListInfo({
      ...listInfo,
      page: page
    });
  };

  return (
    <>
      <SubPage className="fx col">
        <ProjectListCardContainer
          loading={loading}
          handlePageChange={handlePageChange}
          projectList={projectList}
          totalCount={totalCount}
          pageSize={listInfo.pageSize}
          activePage={listInfo.page}
          allowDelete={
            !!projectViews.find((vw) => vw.id === id)?.systemViewProperty
          }
          updateList={updateList}
        />
      </SubPage>
    </>
  );
};

const SubPage = styled.div`
  background: var(--sops-lightpurple-to-black-bg);
  height: 100%;
  padding: 0px !important;
`;

export default injectIntl(withRouter(ProjectListCard));
